export const UPDATE_SEARCH_DETAILS = 'UPDATE_SEARCH_DETAILS'
export const TOGGLE_SINGLE_FLIGHT = 'TOGGLE_SINGLE_FLIGHT'
export const TOGGLE_MULTIPLE_DESTINATIONS = 'TOGGLE_MULTIPLE_DESTINATIONS'

export const updateSearchDetails = data => {
  return {
    type: UPDATE_SEARCH_DETAILS,
    data,
  }
}

export const toggleSingleFlight = () => {
  return {
    type: TOGGLE_SINGLE_FLIGHT,
  }
}

export const toggleMultipleDestinations = () => {
  return {
    type: TOGGLE_MULTIPLE_DESTINATIONS,
  }
}
